import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

interface IBuildApiClient {
  baseUrl: string;
  headers?: () => { [key: string]: string | null };
  onError?: (error: any, apiClient: AxiosInstance) => any;
}

export const buildApiClient = ({
  baseUrl,
  headers = () => ({}),
  onError,
}: IBuildApiClient) => {
  const apiClient = axios.create({ baseURL: baseUrl, withCredentials: false });

  const requestInterceptor: (
    config: AxiosRequestConfig,
  ) => AxiosRequestConfig = (config) => {
    config.headers = { ...config.headers, ...headers() };

    return config;
  };

  const responseErrorInterceptor = (err: any) => {
    if (onError) {
      return onError(err, apiClient);
    }

    return Promise.reject(err);
  };

  apiClient.interceptors.request.use(requestInterceptor);
  apiClient.interceptors.response.use(
    (response) => response,
    responseErrorInterceptor,
  );

  return apiClient;
};
